
import {
	EdgesGeometry,
	Group,
	Mesh,
	LineSegments,
	LineBasicMaterial,
	BoxHelper,
} from '../../../src/js/three.module.js';

//import { MeshObjectLoader } from './mesh-object-loader.js';
//import { MeshObjectLoader } from '../../utils/loaders/mesh-object-loader.js';
import { Oeuvre } from './oeuvre.js';

import { getMeshObjectLoader } from '../../utils/loaders/loader-manager.js';

export class Statue extends Oeuvre {

    constructor( uid, w, h, d, opts, callback ) {

        super( uid, w, h, d );

        this.isStatue = true;

        this.availPlanes = { floor: true, wall: false };

        this.opts = opts || {};

        this.$wireframes = new Group();
        this.$wireframes.visible = false;

        this.setObject(this.opts.obj, callback);
    }

    async setObject(opts, callback = () => { }) {

        var self = this;

        try {

            let mesh;

            if (opts.mesh instanceof Mesh) {

                mesh = opts.mesh;

            } else {

                let loader = /* new MeshObjectLoader() */ getMeshObjectLoader();

                if (opts.attachment_uid) {

                    mesh = await loader.loadAttachment(opts.attachment_uid);

                } else if (opts.path) {

                    mesh = await loader.loadUrl(opts.path);

                }
            }

            if (!mesh)
                throw new Error("Invalid argument :: no opts.mesh nor opts.path available");


            if (opts.scale && !isNaN(opts.scale)) {
                mesh.scale.set(opts.scale, opts.scale, opts.scale);
            }

            if (mesh.geometry) {
                mesh.geometry.center();
            }


            mesh.add(this.$wireframes);

            this.setMesh(mesh);

            if (mesh.geometry) {
                this.$wireframe = new LineSegments(new EdgesGeometry(mesh.geometry), new LineBasicMaterial({ color: 0xffff00, linewidth: 3 }));
            } else {
                this.$wireframe = new BoxHelper(mesh, 0xffff00);
            }

            this.$wireframes.add(this.$wireframe);


            callback(null, mesh);


        } catch (error) {

            callback(error);

        }
    }
}